import './vertical-boxes.scss'
import { loadSvg } from 'js/utility/image.js'
import _ from 'lodash'

export default {
    name: 'vertical-boxes',

    data: {
        iconsSvg: []
    },

    mounted() {
        this.loadIcons()
    },

    methods: {
        loadIcons() {
            this.icons.forEach((url, i) => {
                if (url) {
                    loadSvg(url).then(svg => {
                        const cloneIconsSvg = _.clone(this.iconsSvg)
                        cloneIconsSvg[i] = svg.outerHTML
                        this.iconsSvg = cloneIconsSvg
                    })
                }
            })
        }
    }
}


// WEBPACK FOOTER //
// ./app/theme/components/vertical-boxes/vertical-boxes.js